/* eslint-disable */
import $ from 'jquery';
import { debuglog } from 'util';
//var $ = window.jQuery;
//import ConfigD from './ConfigD';

var Helpers = {
    
    ValidaCPF: function (cpf) {
        if(cpf !=='' && cpf !== undefined ){
            
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf === '') return true; // está assim para poder validar pelo required diretamente no validate
        // Elimina CPFs invalidos conhecidos    
        if (cpf.length !== 11 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999")
            return false;
        // Valida 1o digito 
        var add = 0;
        var i = 0;
        var rev = 0;
        for (i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i), 10) * (10 - i);
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11)
            rev = 0;
        if (rev !== parseInt(cpf.charAt(9), 10))
            return false;
        // Valida 2o digito 
        add = 0;
        for (i = 0; i < 10; i++)
            add += parseInt(cpf.charAt(i), 10) * (11 - i);
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11)
            rev = 0;
        if (rev !== parseInt(cpf.charAt(10), 10))
            return false;
        return true;
        
      }
    },

    CheckDate: function (input) {
        var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
        if (input.match(reg)) {
            return true;
        }
        else {
            return false;
        }
    },

    //retorna uma data formatada de uma string padrão br
    getDateFromString: function (strDate) {
        var day = parseInt(strDate.split("/")[0], 10);
        var month = parseInt(strDate.split("/")[1], 10);
        var year = parseInt(strDate.split("/")[2], 10);
        return new Date(year, month - 1, day);
    },

    //retorna uma string de uma data
    getformattedStringFromDate: function (newDate) {
        var d = new Date(newDate);
        return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
    },

    //adiciona dias úteis para uma data
    addWeekdays: function (fromDate, days) {
        var d = new Date(this.getDateFromString(fromDate));

        
        var count = 0;
        while (count < days) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) // Skip weekends
                count++;
        }
        return d;
    },

    formataReal: function (valor) {
        var num = valor.toString();
        var x = 0;
        var cents = 0;
        var ret;

        if (num < 0) {
            num = Math.abs(num);
            x = 1;
        }
        if (isNaN(num)) num = "0";
        cents = Math.floor((num * 100 + 0.5) % 100);

        num = Math.floor((num * 100 + 0.5) / 100).toString();

        if (cents < 10) cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
            num = num.substring(0, num.length - (4 * i + 3)) + '.'
                + num.substring(num.length - (4 * i + 3));
        ret = num + ',' + cents;
        if (x === 1) ret = ' - ' + ret; return ret;

    },

    // setAutocontraste: function () {
    //     
    //     var contraste = ConfigD.getStore('contraste' || '[]');
    //     // runs functions altocontrraste
    //     if (contraste === null || contraste === 'alto') {
    //         if (!$(this).hasClass("selected")) {
    //             
    //             $("body").addClass("alto-contraste");
    //             $(this).addClass("selected");
    //         } else {
    //             
    //             $("body").removeClass("alto-contraste");
    //             $(this).removeClass("selected");
    //             //ConfigD.setStore('contraste', 'baixo');
    //         }
    //     }

    // },

    formatarTel: function (v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d\d)(\d)/g, "($1) $2");

        if (v.length < 14) {
            v = v.replace(/(\d{4})(\d)/, "$1-$2");
        } else {
            v = v.replace(/(\d{5})(\d)/, "$1-$2");
        }
        return v;
    },

    getBrowser: function () {
        var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE', version: (tem[1] || '') };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR|Edge\/(\d+)/)
            if (tem !== null) { return { name: 'Opera', version: tem[1] }; }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem === ua.match(/version\/(\d+)/i)) !== null) { M.splice(1, 1, tem[1]); }
        return {
            name: M[0],
            version: M[1]
        }
    },

    obterCoresNatureza: function (natureza) {
        switch (natureza) {
            case 'Solicitação':
                return '#8884d8';
            case 'Reclamação':
                return '#83a6ed';
            case 'Sugestão':
                return '#8dd1e1';
            case 'Crítica':
                return '#82ca9d';
            case 'Elogio':
                return '#a4de6c';
            case 'Denúncia':
                return '#d0ed57';
            case 'Improcedente':
                return '#ffc658';
            default:
                return '#d0ed57';
        }
    },

    //http://site112.com/tabela-cores-html
    obterCoresNaturezaRGBa: function (natureza, alfa) {
        switch (natureza) {
            case 'Solicitação':
                return 'rgba(136, 132, 216,' + alfa + ')';
            case 'Reclamação':
                return 'rgba(131, 166, 237,' + alfa + ')';
            case 'Sugestão':
                return 'rgba(141, 209, 225,' + alfa + ')';
            case 'Crítica':
                return 'rgba(130, 202, 157,' + alfa + ')';
            case 'Elogio':
                return 'rgba(164, 222, 108,' + alfa + ')';
            case 'Denúncia':
                return 'rgba(208, 237, 87,' + alfa + ')';
            default:
                return 'rgba(100,149,237,' + alfa + ')';
        }//rgba(208, 237, 87
    },

    obterCoresSituacao: function (situacao) {
        switch (situacao) {
            case 'Encaminhada':
                return '#8884d8';
            case 'Finalizada':
                return '#83a6ed';
            case 'Aberta':
                return '#8dd1e1';
            case 'Solução proposta':
                return '#82ca9d';
            case 'Informação solicitada':
                return '#a4de6c';
            case 'Classificada':
                return '#d0ed57';
            default:
                return '#d0ed57';
        }
    },

    obterCoresAnos: function (ano) {
        switch (ano) {
            case 2012:
                return '#83a6ed';
            case 2013:
                return '#82ca9d';
            case 2014:
                return '#d0ed57';
            case 2015:
                return '#a4de6c';
            case 2016:
                return '#8dd1e1';
            case 2017:
                return '#8884d8';
            default:
                return '#d0ed57';
        }
    },

    DominioMeioConhecimentoDenuncia: function () {
        var ls = [];
        
        var meio = {
            id: 1, descricao: 'Presenciei',
        }
        ls.push(meio);
        var meio = {
            id: 2, descricao: 'Participei',
        }
        ls.push(meio);
        var meio = {
            id: 3, descricao: 'Alguém me contou',
        }
        ls.push(meio);
        var meio = {
            id: 4, descricao: 'Vi uma mensagem',
        }
        ls.push(meio);
        return ls;
    },
    DominioSituacao: function (situacao) {
        switch (situacao) {
            case 201:
                return 'Orçamento aberto';
            case 202:
                return 'Orçamento fechado';
            case 203:
                return 'Orçamento cancelado';
            case 204:
                return 'Orçamento expirado';
            case 205:
                return 'Em andamento';
            case 206:
                return 'Concluído';
            case 207:
                return 'Aguardando qualificação';
            case 208:
                return 'Qualificado';
            case 209:
                return 'Reagendado';
            default:
                return '';
        }
    },

    obterAnos: function () {
        var anoAtual = new Date().getFullYear();
        var anos = [];
        for (var i = 2012; i <= anoAtual; i++) {
            anos.push(i);
        }
        return anos;
    },

    obterFaixaTempoResposta: function (faixa) {
        switch (faixa) {
            case 1:
                return '0 a 5 dias';
            case 2:
                return '6 a 10 dias';
            default:
                return 'Mais de 10 dias';
        }
    },

    obterCoresFaixaTempoRespostaRGBa: function (natureza, alfa) {
        switch (natureza) {
            case '0 a 5 dias':
                return 'rgba(136, 132, 216,' + alfa + ')';
            case '6 a 10 dias':
                return 'rgba(131, 166, 237,' + alfa + ')';
            default:
                return 'rgba(141, 209, 225,' + alfa + ')';
        }
    },

    listaComoArvore(list, idAttr, parentAttr, childrenAttr) {

        

        //Nomes padrões caso não tenha vindo como parâmetro
        if (!idAttr) idAttr = 'id';
        if (!parentAttr) parentAttr = 'parent';
        if (!childrenAttr) childrenAttr = 'children';

        var treeList = [];
        var lookup = {};

        //Coloca na lookup, inserindo o atributo 'id' e recebendo o objeto
        list.forEach(function (obj) {
            lookup[obj[idAttr]] = obj;
            obj[childrenAttr] = [];
        });

        //Da lista original, coloca o filho no atributo children
        list.forEach(function (obj) {
            if (obj[parentAttr] !== null && obj[parentAttr] !== 0 && lookup[obj[parentAttr]]) {

                lookup[obj[parentAttr]][childrenAttr].push(obj);
            } else {
                treeList.push(obj);
            }
        });


        return treeList;
    },

    //https://github.com/react-component/tree-select/blob/master/examples/util.js
    findPath(value, data) {
        
        const sel = [];
        function loop(selected, children) {
            if (children === undefined) {
                
            }
            for (let i = 0; i < children.length; i++) {
                const item = children[i];
                if (selected === item.value) {
                    sel.push(item);
                    return;
                }
                if (item.children) {
                    loop(selected, item.children, item);
                    if (sel.length) {
                        sel.push(item);
                        return;
                    }
                }
            }
        }
        loop(value, data);
        return sel;
    },

    apresentarSpinner(txt){
        $('.page-mask').show();
        $('.txtLoading').text(txt);
    },
    apresentarTxt2(txt) {
        $('.txtLoading2').text(txt);
    },
    removerSpinner() {
        $('.txtLoading').text('loading...');
        $('.txtLoading').text('');
        $('.page-mask').hide();
    },
    
    obteTextoEmoji: function (emoji) {
        switch (emoji) {
            case 1:
                return 'Péssimo';
            case 2:
                return 'Ruim';
            case 3:
                return 'Indiferente';
            case 4:
                return 'Bom';
            case 5:
                return 'Excelente';
            default:
                return 'Sem emoção';
        }
    },
    validateEmail(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
    },
    getBrowser:function() {
		var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
		if(/trident/i.test(M[1])){
			tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
			return {name:'IE',version:(tem[1]||'')};
			}   
		if(M[1]==='Chrome'){
			tem=ua.match(/\bOPR|Edge\/(\d+)/)
			if(tem!=null)   {return {name:'Opera', version:tem[1]};}
			}   
		M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
		if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
		return {
		name: M[0],
		version: M[1]
		}
 },

 obterCoresNatureza:function(natureza){
    switch (natureza) {
       case 'Solicitação':
           return '#8884d8';
       case 'Reclamação':
           return '#83a6ed';
       case 'Sugestão':
           return '#8dd1e1';
       case 'Crítica':
           return '#82ca9d';
       case 'Elogio':
           return '#a4de6c';
       case 'Denúncia':
           return '#d0ed57';
       case 'Improcedente':
           return '#ffc658';
       default:
           return '#d0ed57';
   }
},
//http://site112.com/tabela-cores-html
obterCoresNaturezaRGBa:function(natureza, alfa){
    switch (natureza) {
       case 'Solicitação':
           return 'rgba(136, 132, 216,'+alfa+')';
       case 'Reclamação':
           return 'rgba(131, 166, 237,'+alfa+')';
       case 'Sugestão':
           return 'rgba(141, 209, 225,'+alfa+')';
       case 'Crítica':
           return 'rgba(130, 202, 157,'+alfa+')';
       case 'Elogio':
           return 'rgba(164, 222, 108,'+alfa+')';
       case 'Denúncia':
           return 'rgba(208, 237, 87,'+alfa+')';
       default:
           return 'rgba(100,149,237,'+alfa+')';
   }//rgba(208, 237, 87
},

   obterCoresNotaNPSRGBa: function (nota, alfa) {
       switch (nota) {
           case 0:
               return 'rgba(234, 51, 51,' + alfa + ')';
           case 1:
               return 'rgba(234, 51, 51,' + alfa + ')';
           case 2:
               return 'rgba(234, 51, 51,' + alfa + ')';
           case 3:
               return 'rgba(234, 51, 51,' + alfa + ')';
           case 4:
               return 'rgba(234, 51, 51,' + alfa + ')';
           case 5:
               return 'rgba(234, 51, 51,' + alfa + ')';
           case 6:
               return 'rgba(249, 203, 76,' + alfa + ')';
           case 7:
               return 'rgba(249, 203, 76,' + alfa + ')';
           case 8:
               return 'rgba(249, 203, 76,' + alfa + ')';
           case 9:
               return 'rgba(104, 179, 79,' + alfa + ')';
           case 10:
               return 'rgba(104, 179, 79,' + alfa + ')';
           default:
               return 'rgba(100,149,237,' + alfa + ')';
       }//rgba(208, 237, 87
   },

 obterCoresSituacao:function(situacao){
    switch (situacao) {
       case 'Encaminhada':
           return '#8884d8';
       case 'Finalizada':
           return '#83a6ed';
       case 'Aberta':
           return '#8dd1e1';
       case 'Solução proposta':
           return '#82ca9d';
       case 'Informação solicitada':
           return '#a4de6c';
       case 'Classificada':
           return '#d0ed57';
       default:
           return '#d0ed57';
   }
},
 obterCoresAnos:function(ano){
    switch (ano) {
       case 2012:
           return '#83a6ed';
       case 2013:
           return '#82ca9d';
       case 2014:
           return '#d0ed57';
       case 2015:
           return '#a4de6c';
       case 2016:
           return '#8dd1e1';
       case 2017:
           return '#8884d8';
       case 2018:
           return '#5792ed';
       case 2019:
           return '#b457ed';
        default:
           return '#d0ed57';
   }
},

 obterAnos:function(){
   var anoAtual = new Date().getFullYear();
   var anos =[];
   for (var i = 2012; i <= anoAtual; i++) {
      anos.push(i);
   }
   return anos;
},


};

module.exports = Helpers;



/** WEBPACK FOOTER **
 ** ./src/components/util/Helpers.js
 **/